/* eslint-disable unused-imports/no-unused-vars */
import React, { memo, useCallback, useEffect, useState } from "react";

import { MenuItem, SelectChangeEvent } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import SelectComponent from "Components/Form/SelectComponent/SelectComponent";

import { ExternalList } from "../../../../../../context/MovingResources";
import { useAppState } from "../../../../../../context/StateContext";
import { JobMode } from "../../../../../../models/job.mode";
import ModeJobService from "../../../../../../services/mode.job.service";
import { Mode, ShipmentType, Status } from "../../../../../../util/enums";
import { MAPPING_IMAGE_SHIPMENT_TYPE } from "../../constants/Waybills.const";
import { Ship } from "iconsax-react";

interface Props {
  shipmentTypes: any[];
  onChangeFilter: (value: ShipmentType) => void;
  value?: ShipmentType;
}

const SelectTypeShipment = function ({ value, shipmentTypes, onChangeFilter }: Props) {
  const { t: translate } = useTranslation();
  const [valueType, setValueType] = useState<string>(value || ShipmentType.SEA);

  const renderUI = useCallback(() => {
    return (
      <SelectComponent
        bordercolor="green"
        style={{
          minWidth: "150px",
        }}
        value={valueType}
        data-cy="mode"
        onChange={(e: SelectChangeEvent<any>) => {
          const value = e.target.value as ShipmentType;
          setValueType(value);

          onChangeFilter(value);
        }}
        displayEmpty
      >
        {shipmentTypes.map((mode) => (
          <MenuItem key={mode.id} value={mode.value} data-cy={`mode-value-${mode.name}`}>
            <div className="d-flex flex-row" style={{ gap: "12px" }}>
              <img src={mode?.image} />
              <div>{translate(mode.value.toLowerCase()) || mode.name}</div>
            </div>
          </MenuItem>
        ))}
      </SelectComponent>
    );
  }, [shipmentTypes, onChangeFilter, valueType]);

  return renderUI();
};

export default SelectTypeShipment;
